import { defineStore } from "pinia";
const apiServer = process.env.VUE_APP_API_SERVER;

export const useApiStore = defineStore({
  id: "useApiStore", //ストアの識別子

  //状態を定義
  state: () => ({
    path: apiServer,
  }),

  //状態から派生した値を取得するためのゲッター
  getters: {
    getConfig: (state) => state.path,
    getArticlePath: (state) => `${state.path}/api/v1/article`,
    getArticlePathForId: (state) => (id) =>
      `${state.path}/api/v1/article/${id}`,
    getImagePathForDir: (state) => (imageDir) =>
      `${state.path}/api/image/${imageDir}`,
    getYosoPath: (state) => (date, place, race) =>
      `${state.path}/api/v1/yoso/${date}/${place}/${race}`,
    getYoutubePath: (state) => `${state.path}/api/v1/youtube`,
    getYoutubeEditPathForId: (state) => (id) =>
      `${state.path}/api/v1/youtube/${id}`,
    getYoutubeEditPathForIdV2: (state) => (id) =>
      `${state.path}/api/v2/youtube/${id}`,
    getYoutubeEditPathForIdV3: (state) => (id) =>
      `${state.path}/api/v3/youtube/${id}`,
    getYoutubeEditPath: (state) => `${state.path}/api/v1/youtube`,
    getLoginPath: (state) => `${state.path}/api/login`,
    getXmlPath: (state) => `${state.path}/api/v1/xml`,
    getXmlPathForDate: (state) => (date) => `${state.path}/api/v1/xml/${date}`,
    getSitePath: (state) => `${state.path}/api/v1/site`,
    getSitePathForId: (state) => (id) => `${state.path}/api/v1/site/${id}`,
    getRankingPath: (state) => `${state.path}/api/v1/ranking`,
    getRankingPathForId: (state) => (id) =>
      `${state.path}/api/v1/ranking/${id}`,
    getCsvPath: (state) => `${state.path}/api/v1/csv`,
    getCsvPathForKind: (state) => (kind) => `${state.path}/api/v1/csv/${kind}`,
    getMaintenansPath: (state) => `${state.path}/api/v1/maintenans`,
    getMaintenancePath: (state) => `${state.path}/api/v1/maintenance`,
    getUsersPath: (state) => `${state.path}/api/v1/users`,
    getUsersPathForId: (state) => (id) => `${state.path}/api/v1/users/${id}`,
    getSpecialsitePath: (state) => `${state.path}/api/v1/specialsite`,
    getProfilePath: (state) => `${state.path}/api/v1/profile`,
    getRolesPath: (state) => `${state.path}/api/v1/roles`,
    getWritersPath: (state) => `${state.path}/api/v1/writers`,
    getIssuekeyPath: (state) => `${state.path}/api/v1/issuekey`,
  },
});
